let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1lhzn")).then(() => parcelRequire('gxLxy'));